import { Component } from '@angular/core';
import { FormlyFieldMultiCheckbox } from '@ngx-formly/material/multicheckbox';

@Component({
    selector: 'lockton-apps-multi-checkbox-type',
    templateUrl: './multi-checkbox-type.component.html',
    styleUrls: ['./multi-checkbox-type.component.scss'],
    standalone: false
})
export class MultiCheckboxTypeComponent extends FormlyFieldMultiCheckbox {}
